module.exports = __webpack_public_path__ + "static/fonts/ProximaNovaA-Bold.f871a86a.ttf";